module.exports = __webpack_public_path__ + "b551016fbdf64b9d22f1c7b34a6a3a8d.svg";